import React from 'react';
import { RingLoader } from 'react-spinners';

const Loader = () => {
  return (
    <div className="loader">
      <RingLoader
        color="#50d22f"
        size={60}
      />
    </div>
  );
};

export default Loader;
